/* eslint-disable require-jsdoc */
import {getEventHtml} from './event/event';
import http from '../../services/http';
import $, {data} from 'jquery';
import {getBandsHtml} from './band/band';
import {getVenueHtml} from './venue/venue';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// import * as config from '../../config.json';
import {initMap} from './initMap';
import { pApiBase, debug, isHearby } from '../../../../config';
import { isValid } from '../../utils/validate';

function getMidY(selector) {
  const ele = document.querySelector(selector);
  const eleRect = ele.getBoundingClientRect();
  return eleRect.top + (eleRect.height / 2);

}
function getHeight(selector){
  const ele = document.querySelector(selector);
  const eleRect = ele.getBoundingClientRect();
  return ele.height;
}

function targetCurrentMapPopUp(popUp){
  const popUpTarget = document.querySelector(`.hearby-map-inner-popup-${popUp.widgetID}`);
  return popUpTarget;
}

function openPopUp(popUp) {
  // document.body.style.position = 'fixed';
  // console.log('popUpTarget', targetCurrentMapPopUp(popUp));
  disableBodyScroll(targetCurrentMapPopUp(popUp));
  
  //const HalfCarDetHeight = getHeight('.hearby-event-detail-overlay') / 2;
  //const scrollY = document.documentElement.scrollTop;
  // $('body,html').css({overflow: 'visible', position: 'inherit'});
  // popUp.currentScrollY = document.documentElement.scrollTop || document.body.scrollTop;
 // if (!isHearby) {
    const midMapY = getMidY('.hearby-map-1');
    const carouselDetailOverlay = $('.hearby-event-detail-overlay');
    $(carouselDetailOverlay).css({ position: 'fixed', marginTop: '20px' });
 // }
  const carouselDetail = $(popUp.popUpId);
  debug && console.log(popUp.popUpId);
  carouselDetail.css({display: 'block'}); 
  
  
  
  //document.documentElement.scrollTop = document.body.scrollTop = scrollY;
  
  closePopUpListener(popUp);
}

function getPopUpHtml(popUpObj, data) {
  const eventHtml = getEventHtml(popUpObj, data);
  const bandHtml = getBandsHtml(data.bands);
  const venueHtml = getVenueHtml(data, popUpObj);
  return `
  ${eventHtml}
  ${bandHtml}
  ${venueHtml}

               `;
}
function setPopUp(carousel, popUp) {
  debug && console.log('in set pop up');
  const carouselSelector = $(carousel.mapId);
  const popUpSelector = '.event_popup';
  debug && console.log(popUpSelector);
  debug && console.log(carouselSelector);
  carouselSelector.on('mousedown', popUpSelector, function(evt1) {
    carouselSelector.on('mouseup', popUpSelector, function handler(evt2) {
      if (
        evt2.type === 'mouseup' &&
        Math.abs(evt1.pageX - evt2.pageX) < 5 &&
        Math.abs(evt1.pageY - evt2.pageY) < 5
      ) {
        // click
        // eslint-disable-next-line no-invalid-this
        popUp.eventId = $(this).attr('event-id');
        // eslint-disable-next-line no-invalid-this
        popUp.dist = $(this).attr('event-dist');
        createPopUp(popUp);
      } else {
        // drag
      }
    });
  });
}
async function createPopUp(popUp) {
  const queryStr =
    `${pApiBase}` + '/event-detail-tile?event_guid=' + popUp.eventId;
  const auth = false;
  debug && console.log(queryStr);
  const popUpData = await http.get(queryStr, auth);
  popUp.lat=popUpData.lat;
  popUp.lng=popUpData.lng;
  const popUpHtml = getPopUpHtml(popUp, popUpData);
  popUp.MapCenter = {lat: popUpData.lat, lng: popUpData.lng};
  debug && console.log('pop up html    ', popUpHtml);
  debug && console.log('pop up data    ', popUpData);
  const popUpId = popUp.popUpId;
  // const venue_args = '?venue_id=' + this.venue.id;
  // const active = false;
  // const infowindow_query_base =
  //   'https://a4backend.net:8000/venue-info';
  debug && console.log('tesssting ', popUp);
  debug && console.log('test',popUpData);
  $(function() {
    $(popUpId).find('.content').html(popUpHtml);
    // A4map.init(popUp.mapId);
    openPopUp(popUp);
    debug && console.log('popup test ', popUp);
    initMap(popUp, popUpData);
    // getPopUpHtml(popUp, popUpData);
  });
}
function closePopUpListener(popUp) {
  const carouselDetailClose = $(popUp.popUpId) // jQuery(popUp.popUpId)
      .find('.close');

  // const popUpHeight=isValid(document.getElementsByClassName('event_popup-1')) ? 
  //   document.getElementsByClassName('event_popup-1').style.height: null;

  debug && console.log(carouselDetailClose);
  const scrollY = 400;
  carouselDetailClose.on('click', async (e) => {
    hidePopUp(popUp);
    enableBodyScroll(targetCurrentMapPopUp(popUp));
    e.stopPropagation();
    // document.documentElement.scrollTop = document.body.scrollTop = scrollY;
  });

$('body').on('click', async (e) => {
  debug && console.log('e.target: ', popUp);
  if (isValid(e.target.children[0])) {
    if(e.target.children[0].className ===
      `${popUp.popUpId.substring(1)} hearby-map-inner-popup-${popUp.widgetID}`) {
        hidePopUp(popUp);
        enableBodyScroll(targetCurrentMapPopUp(popUp));
        e.stopPropagation();
     }  
  }   
});

  debug && console.log('scroll y 2', scrollY);
  // window.scrollTo(0, parseInt(scrollY) * -1);
}
async function hidePopUp(popUp) {
  const popUpSelector = document.querySelector(popUp.popUpId);
  debug && console.log(popUpSelector);
  document.querySelector(`${popUp.popUpId} .hearby-map-inner-popup-${popUp.widgetID}`).scrollTop = 0;
  $(popUpSelector).css({display: 'none'});
}
export {createPopUp, setPopUp, closePopUpListener};
